import React from 'react';
import PropTypes from 'prop-types';

import CommunitiesListItem from './CommunitiesListItem';
import AreasSearchWrapper from './AreasSearchWrapper';

export function CommunitiesListComponent({ communities, handleClick }) {
  return (
    <AreasSearchWrapper
      areas={communities}
      render={({ areas, searchMinPop, searchMaxPop }) =>
        areas.map(community => (
          <CommunitiesListItem
            key={`${community.id}${community.intid}`}
            favoritesType="communities"
            community={community}
            showPopulation={searchMinPop !== 0 || searchMaxPop !== Infinity}
            handleClick={handleClick}
          />
        ))
      }
    />
  );
}

CommunitiesListComponent.propTypes = {
  communities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    }),
  ).isRequired,
  handleClick: PropTypes.func.isRequired,
};

export default CommunitiesListComponent;



// WEBPACK FOOTER //
// ./src/components/List/Areas/CommunitiesList.js